export const STATUS_LABEL: Record<string, string> = {
  RASCUNHO: 'Rascunho',
  ENVIADO: 'Enviado',
  AGUARDANDO_ASSINATURA: 'Aguardando assinatura',
  EM_ANALISE: 'Em Análise',
  APROVADO: 'Aprovado',
  DEVOLVIDO_CORRECAO: 'Devolvido para correção',
  REPROVADO: 'Reprovado',
  CONCLUIDO: 'Concluído',
  EM_PRESTACAO: 'Em prestação',
  FECHADO: 'Fechado',
};

export const STATUS_COLOR: Record<string, string> = {
  RASCUNHO: 'border-line bg-surface-muted text-fg',
  ENVIADO: 'border-info-line bg-info-soft text-info-fg',
  AGUARDANDO_ASSINATURA: 'border-info-line bg-info-soft text-info-fg',
  EM_ANALISE: 'border-info-line bg-info-soft text-info-fg',
  APROVADO: 'border-success-line bg-success-soft text-success-text',
  DEVOLVIDO_CORRECAO: 'border-warning-line bg-warning-soft text-warning-text',
  REPROVADO: 'border-danger-line bg-danger-soft text-danger-text',
  CONCLUIDO: 'border-success-line bg-success-soft text-success-text',
  EM_PRESTACAO: 'border-info-line bg-info-soft text-info-fg',
  FECHADO: 'border-line-strong bg-line text-fg',
};

export const ETAPA_LABEL: Record<string, string> = {
  ORCAMENTO: 'Orçamento',
  CONVENIOS_ANALISE: 'Convênios - análise inicial',
  GESTOR_PARCERIA: 'Gestor da parceria',
  COMISSAO_SELECAO: 'Comissão de seleção',
  CONVENIOS_MINUTA: 'Convênios - minuta do termo de fomento',
  PROCURADORIA_JURIDICA: 'Procuradoria Geral Municipal',
  CONVENIOS_FORMALIZACAO: 'Convênios - formalização do termo de fomento',
  CONCLUIDO: 'Concluído',
};

export const MODALIDADE_LABEL: Record<string, string> = {
  TERMO_COLABORACAO: 'Termo de Colaboração',
  TERMO_FOMENTO: 'Termo de Fomento',
};

export const ETAPA_ANEXO_OBRIGATORIO: Record<string, { tipo: string; label: string } | undefined> = {
  CONVENIOS_ANALISE: { tipo: 'PLANO_TRABALHO_ASSINADO_PREFEITO', label: 'Plano de trabalho assinado pela instituição e Prefeito' },
  COMISSAO_SELECAO: { tipo: 'ATA_COMISSAO', label: 'Ata da comissão' },
  CONVENIOS_MINUTA: { tipo: 'MINUTA_TERMO_FOMENTO_ASSINADA', label: 'Minuta do termo de fomento' },
  CONVENIOS_FORMALIZACAO: { tipo: 'TERMO_FOMENTO', label: 'Termo de fomento assinado' },
};
